module.exports = __webpack_public_path__ + "img/task-details.78db8338.png";